import { createAsyncThunk } from '@reduxjs/toolkit';
import { RedcatApiHandler } from 'polygon-utils';
import { OrderingOperations, OrderingApi } from 'polygon-ordering';
import debug from '../utils/debug';
import { determineEndpoint } from '../utils/endpoint';
import { clearCookies } from '../thunks/clearCookies';
import { setApiHandlerReady } from '../slices/apiHandlerReady';
import { IN_DEVELOPMENT } from '../constants';

export const configureApiHandler = createAsyncThunk(
  'configureApiHandler',
  async (_data: undefined, { dispatch }) => {
    const endpoint = determineEndpoint();

    debug('api endpoint', { endpoint });

    RedcatApiHandler.endpointDeterminer = () => endpoint!;

    RedcatApiHandler.additionalParamsDeterminer = () => {
      const memberAuthTokenOverridePresent = localStorage.getItem('memberAuthToken') != null;

      // don't send auth cookie if an override exists
      // in dev, the API runs on a different port (cross-origin), so 'same-origin' would drop the session cookie
      if (memberAuthTokenOverridePresent) {
        return { credentials: 'omit' };
      }
      return { credentials: IN_DEVELOPMENT ? 'include' : 'same-origin' };
    };
    RedcatApiHandler.authTokenDeterminer = () => {
      // if override not present, cookies will be used instead
      return localStorage.getItem('memberAuthToken')!;
    };

    RedcatApiHandler.badAuthTokenHook = () => {
      debug(false, 'badAuthTokenHook');
      dispatch(clearCookies());
    };

    RedcatApiHandler.requestErrorHook = () => {};

    OrderingApi.setHandler(RedcatApiHandler);
    dispatch(OrderingOperations.setApiHandlerReady(true)); // TODO: remove this from OM
    dispatch(setApiHandlerReady());
  },
);
